import { useTranslation } from 'react-i18next';
import { getScoreColor } from '../../../utilities/common/color';
import ArrowDown from '../../../assets/icons/arrow_down.svg';

interface ScoreBarProps {
  data: {
    score: number;
    benchmark: number;
  };
}

export default function ScoreBar({ data }: ScoreBarProps) {
  const { t } = useTranslation();

  return (
    <div className="intl-widget-ignore-element flex h-full w-full min-w-[200px] flex-col justify-center px-2">
      <div className="relative flex justify-between text-[12.97px] text-black-500">
        <div
          className="absolute flex flex-col items-end "
          style={{ width: `${data.score}%` }}
        >
          <div className="absolute -right-4 -top-12 z-10 inline-block rounded-lg bg-black-950 px-3 py-2 text-xs font-semibold text-white">
            {data.score}
            <div className="intl-widget-ignore-element absolute left-1/2 h-3 w-3 -translate-x-1/2 rotate-45 rounded-[1px] bg-inherit"></div>
          </div>
        </div>

        <div className="intl-widget-ignore-element relative flex h-full w-full items-center">
          <div className="intl-widget-ignore-element absolute flex h-2 w-full rounded-lg bg-black-200"></div>
          <div
            id="progress-bar"
            className={`intl-widget-ignore-element absolute flex h-2 rounded-lg ${getScoreColor(
              data.score,
              data.benchmark,
            )}`}
            style={{ width: `${data.score}%` }}
          ></div>
        </div>

        <div
          className="absolute flex flex-col items-end "
          style={{ width: `${data.benchmark}%` }}
        >
          <div className="mr-[-62px] mt-2 flex flex-col items-center">
            <img src={ArrowDown} alt="arrow down" />
            <p className="mt-4">
              {t('intellectBenchmark')}: {data.benchmark}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
